import * as React from "react";

import { ILeanSvgIconWithColor } from "../ILeanSvgIconWithColor";

export const star: React.FunctionComponent<ILeanSvgIconWithColor> = ({ iconColor, ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...rest}>
      <path
        fill="none"
        stroke={iconColor}
        d="M10 9.5 4.5 9.5 9 13 7 18.799 12 15.5 17 18.799 15 13 19.5 9.5 14 9.5 12 3.5z"
      />
    </svg>
  );
};
